import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { topBarImages } from "../../../../reusableUI/images";
import secureLocalStorage from "react-secure-storage";
import { CiLogout } from "react-icons/ci";
import { capitalizeFirstLetter } from "../../../../utils/Functions";
import { LuDelete } from "react-icons/lu";
import { FaBuildingUser } from "react-icons/fa6";
import { MdLogout } from "react-icons/md";
const TopBar = ({ searchTerm, setSearchTerm }) => {
  const [role, setRole] = useState("");
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [partnerName, setPartnerName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const storedPartnerName = secureLocalStorage.getItem("partnerName");
    const isAuth = secureLocalStorage.getItem("isAuth");
    const userRole = secureLocalStorage.getItem("role");

    setPartnerName(storedPartnerName || "");
    setRole(userRole || "");

    if (!isAuth) {
      secureLocalStorage.setItem("isAuth", false);
      secureLocalStorage.clear();
      localStorage.clear();
      setSearchTerm("");
      navigate("/admin/login");
    }
  }, [navigate, setSearchTerm]);

  const handleLogout = () => {
    secureLocalStorage.removeItem("isAuth");
    secureLocalStorage.removeItem("isAuthHospital");
    secureLocalStorage.clear();
    localStorage.clear();
    setSearchTerm("");

    if (role === "hospital") {
      navigate("/partner/login");
    } else {
      navigate("/admin/login");
    }
  };

  const handleClear = () => {
    setSearchTerm("");
  };

  const isPartnerUser = !!partnerName;

  return (
    <>
      <div className="flex items-center justify-between mt-[-1.50rem] p-0 w-full">
        {/* Search Bar */}
        <div className="flex items-center justify-between bg-white rounded-md shadow-md p-1 h-10 my-5 mx-1 w-3/5">
          <div className="flex items-center w-full">
            <img
              src={topBarImages.search}
              className="h-4 w-4 ml-2.5"
              alt="Search Icon"
            />
            <input
              type="text"
              placeholder="Search"
              className="border-none ml-2.5 w-full h-full focus:outline-none placeholder-medium bg-transparent"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                color: "black",
                caretColor: "blue",
              }}
            />
          </div>

          <div onClick={handleClear} className="mr-2 cursor-pointer">
            <LuDelete size={20} color="gray" />
          </div>
        </div>

        {/* Right Section */}
        <div className="flex items-center mr-3 ml-0 md:ml-8 ">
          {isPartnerUser ? (<>
            <div className="flex items-center gap-4   px-4 py-2 h-10 ">
              <div className="flex flex-row items-center gap-2 ">
                <div className=" p-2 w-8 h-8"> <FaBuildingUser color={"blue"} size={16} /></div>

                <span className="text-[13px] font-medium font-poppins text-[#1f1f1f] whitespace-nowrap">
                  {capitalizeFirstLetter(partnerName)}
                </span></div>


            </div>
            <div className="flex flex-row items-center bg-[white] shadow-md rounded-lg p-2">
              {/* <p>Logout</p> */}
              <button
                onClick={() => setShowLogoutModal(true)}
                className="text-[#4951EC] hover:text-[#2f37d3] transition "
                title="Logout"
              >
                <MdLogout size={20} />

              </button>

            </div></>
          ) : (
            <div className="flex flex-row items-center">
              <button className="bg-custom-gradient transition delay-700 duration-300 ease-in-out hover:-translate-y-1 hover:scale-110 text-white px-6 p-2 ml-1 rounded-md text-[14px] h-10">
                {capitalizeFirstLetter(role === "hospital" ? partnerName : "Admin")}
              </button>

              <button
                className="border border-[#4951EC] text-blue-600 px-6 p-2 ml-2 rounded-md text-[14px] h-10"
                onClick={() => setShowLogoutModal(true)}
              >
                Log Out
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Logout Modal */}
      {showLogoutModal && (
        <div className="w-full fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div className="flex flex-col items-center bg-white rounded-lg shadow-lg p-6 py-12 w-[90%] md:max-w-[22%]">
            <div className="bg-[#e9eef0] rounded-full flex items-center justify-center p-3 mb-4">
              <CiLogout size={26} color="black" />
            </div>

            <h3 className="text-[16px] font-semibold text-center mb-10">
              Are you sure you want to log out?
            </h3>

            <div className="flex justify-center space-x-4">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="text-[#4951EC] px-6 py-2 rounded-md text-[16px]"
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="bg-custom-gradient text-white px-6 py-2 rounded-md hover:bg-blue-600 transition duration-200 text-[16px]"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TopBar;